import React from 'react'

interface IProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  onClickButNotDrag?: (e: React.FormEvent<HTMLDivElement>) => void
}

class SuperDiv extends React.PureComponent<IProps> {
  private clickStartCoords = {
    x: 0,
    y: 0,
  }

  startClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.clickStartCoords = {
      x: e.clientX,
      y: e.clientY,
    }
  }

  finishClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (
      this.props.onClickButNotDrag &&
      Math.abs(this.clickStartCoords.x - e.clientX) < 5 &&
      Math.abs(this.clickStartCoords.y - e.clientY) < 5
    ) {
      return this.props.onClickButNotDrag(e)
    }

    this.props.onClick && this.props.onClick(e)
  }

  render() {
    const { onClickButNotDrag, children, ...other } = this.props
    return (
      <div
        {...other}
        onMouseDown={this.startClick}
        onMouseUp={this.finishClick}
        onClick={undefined}
      >
        {children}
      </div>
    )
  }
}

export default SuperDiv
